import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core';

@Directive({
  selector: '[appClickOutside]',
  standalone: true,
})
export class ClickOutsideDirective {
  @Output()
  clickOutside = new EventEmitter<MouseEvent>();

  constructor(private _ref: ElementRef) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onClickOutside(event: MouseEvent): void {}

  @HostListener('document:click', ['$event', '$event.target'])
  onDocumentClicked(event: MouseEvent, targetElement: HTMLElement): void {
    if (
      targetElement &&
      document.body.contains(targetElement) &&
      !this._ref.nativeElement.contains(targetElement)
    ) {
      this.clickOutside.emit(event);
      this.onClickOutside(event);
    }
  }
}
